import React from 'react';
import PropTypes from 'prop-types';

const Checkbox = (props) => {
    const {
        name, label, isChecked, placeholder, disabled, handleChange,
    } = props;
    return (
        <div id="forms_container">
            <fieldset>
                <div className="form-group input-field">
                    <div className="single-input">
                        {
                            label && (
                                <label>
                                    <input
                                        type="checkbox"
                                        name={name}
                                        placeholder={placeholder}
                                        checked={isChecked}
                                        onChange={handleChange}
                                        disabled={disabled}
                                    />{label}
                                </label>
                            )
                        }
                    </div>
                </div>
            </fieldset>
        </div>
    );
};

Checkbox.defaultProps = {
    name: '',
    label: '',
    isChecked: false,
    disabled: false,
    placeholder: '',
};

Checkbox.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    isChecked: PropTypes.bool,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    handleChange: PropTypes.func.isRequired,
};

export default Checkbox;
